@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="row">
  <div class="span9">
    <h1 data-automation-name="reportHistoryIndex"> Report History for {{registered_report_id}} </h1>
  </div>
  <p class="lead">
    Each attempted send of a registered report is logged. Those that received replies were accepted, and the others rejected.
  </p>
</div>

@if(isLoading) {
  <app-loader
    message="Loading Report History...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>Request ID</th>
      <th>Registered Report ID</th>
      <th>Date</th>
      <th># Intervals sent</th>
      <th>Received reply</th>
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="Request ID" class="input-sm form-control" type="search" [(ngModel)]="requestIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Registered Report ID" class="input-sm form-control" type="search" [(ngModel)]="registeredReportIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Date" class="input-sm form-control" type="search" [(ngModel)]="dateSearch" (input)="triggerSearch()"/></th>
      <th></th>
      <th>
        <select class="input-sm form-control" [(ngModel)]="receivedReplySearch" (change)="triggerSearch()">
          <option value="">All</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </th>
    </tr>
    </thead>
    <tbody>
      @for(history of displayedReportHistory | paginate: paginationModel; track history) {
        <tr class="table-active">
          <td>{{history.request_id}}</td>
          <td>{{history.registered_report_id}}</td>
          <td>{{history.dttm}}</td>
          <td>{{history.intervals_sent}}</td>
          <td>
            @switch(Boolean(history.success)) {
              @case(true) {
                <span class="badge badge-success">Yes</span>
              }
              @default {
                <span class="badge badge-danger">No</span>
              }
            }
          </td>
        </tr>
      }
      @if(displayedReportHistory.length <= 0) {
        <tr>
          <td colspan="5" style="text-align: center;">No report history found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" colspan="5">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
